'use client'
import { CurationContext } from '@/app/(site)/edit/gifs/curation-context'
import { cn } from '@/util/cn'
import { IGif } from '@giphy/js-types'
import { getGifHeight } from '@giphy/js-util'
import { Video } from '@giphy/react-components'
import { useContext } from 'react'
import { SoundOnIcon } from 'ui/src/icons/player'

interface AudioOverlayProps {
    gif: IGif
    isHovered?: boolean
    width?: number
}

const AudioOverlay = ({ gif, isHovered = false, width }: AudioOverlayProps) => {
    const curationContext = useContext(CurationContext)

    if (!curationContext) {
        return null
    }

    const { soundOn, setSoundOn } = curationContext

    return gif.type === 'video' ? (
        <div className="absolute inset-0">
            {soundOn && isHovered && (
                <Video gif={gif} width={width || 0} height={getGifHeight(gif, width || 0)} muted={false} loop />
            )}
            <SoundOnIcon
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setSoundOn(!soundOn)
                }}
                color="#fff"
                className={cn('absolute top-4 left-4 h-6 w-6 cursor-pointer opacity-70', isHovered && 'opacity-100')}
            />
        </div>
    ) : null
}

export default AudioOverlay
